import finger from "@assets/img/emoji/fingerup.png";
import { BreakdownWithEmoji } from "../../../../shared";
import { useOnboardingTexts } from "src/routes/onboarding/shared/hooks/useOnboardingTexts";

const data = {
  LOSE_WEIGHT: "slim down at your own pace and pleasure",
  MAINTAIN_WEIGHT: "tone up and look fit"
};

export const WeKnow = ({ onNextStep, onTrackEvent }) => {
  const { getSectionText } = useOnboardingTexts();
  
  const paragraph1 = getSectionText("feedback_weight_goal").title;
  const paragraph2 = getSectionText("feedback_weight_goal").description;

  const value = localStorage.getItem("mainGoal");
  const content = data[value];
  const title = "We know how to make it happen!";
  const paragraph = [
    paragraph1,
    `${paragraph2} <strong>${content}</strong> in just 15-min a day.`
  ];
  return (
    <BreakdownWithEmoji
      emoji={finger}
      title={title}
      paragraph={paragraph}
      onContinue={() => {
        onNextStep();
        onTrackEvent();
      }}
    />
  );
};
